import { jsxs, jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { Badge } from "./Badge.js";
import { token } from "./token.js";
import { useCardContext } from "./context.js";
function Frame({
  children,
  progressBar,
  badge,
  icon,
  isCheckeredBackground = false,
  height = "fixed",
  ...props
}) {
  const {
    variant,
    isSelected
  } = useCardContext();
  return /* @__PURE__ */ jsxs(FrameStyled, {
    $isCheckeredBackground: isCheckeredBackground,
    $height: height,
    ...props,
    children: [variant === "clean" && isSelected && /* @__PURE__ */ jsx(FocusRing, {}), /* @__PURE__ */ jsx(Children, {
      $height: height,
      children
    }), /* @__PURE__ */ jsx(Overlay, {}), progressBar ? /* @__PURE__ */ jsx(ProgressContainer, {
      children: progressBar
    }) : null, badge ? /* @__PURE__ */ jsx(BadgeContainer, {
      children: /* @__PURE__ */ jsx(Badge, {
        color: "black-alpha",
        children: badge
      })
    }) : null, icon ? /* @__PURE__ */ jsx(IconContainer, {
      children: icon
    }) : null]
  });
}
const FrameStyled = styled.div.withConfig({
  displayName: "FrameStyled",
  componentId: "sc-1bnqt8s-0"
})(["position:relative;min-height:92px;border-radius:var(--card-frame-border-radius);background:", ";", ""], (props) => props.$isCheckeredBackground ? `url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Crect height='12' width='12' y='0' x='0' fill='%23ffffff'/%3E%3Crect height='6' width='6' y='0' x='0' fill='%23e9ecee'/%3E%3Crect height='6' width='6' y='6' x='6' fill='%23e9ecee'/%3E%3C/svg%3E%0A") ` : token.gray25, (props) => props.$height === "fixed" && css(["&::before{content:'';display:inline-block;vertical-align:top;width:0;height:0;padding-bottom:calc(100% / (16 / 10));}"]));
const FocusRing = styled.div.withConfig({
  displayName: "FocusRing",
  componentId: "sc-1bnqt8s-1"
})(["position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px;border:var(--card-selected-border-width) solid var(--card-selected-border-color);border-radius:calc(var(--card-border-radius) + 4px);"]);
const Children = styled.div.withConfig({
  displayName: "Children",
  componentId: "sc-1bnqt8s-2"
})(["", " display:grid;overflow:hidden;border-radius:var(--card-frame-border-radius);"], (props) => props.$height === "fixed" && css(["position:absolute;inset:0;"]));
const Overlay = styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-1bnqt8s-3"
})(["position:absolute;top:0;left:0;box-sizing:border-box;width:100%;height:100%;border:var(--card-inner-border-width) solid var(--card-inner-border-color);border-bottom-width:var(--card-frame-border-bottom-width);border-radius:var(--card-frame-border-radius);background:var(--card-frame-overlay-color);"]);
const BadgeContainer = styled.div.withConfig({
  displayName: "BadgeContainer",
  componentId: "sc-1bnqt8s-4"
})(["position:absolute;right:", ";bottom:", ";"], token.spacing4, token.spacing4);
const IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1bnqt8s-5"
})(["position:absolute;bottom:", ";left:", ";color:", ";path{stroke:", ";stroke-width:2px;paint-order:stroke;&[d='M0 0h24v24H0z']{stroke:none;}}"], token.spacing4, token.spacing4, token.white, token.gray100a);
const ProgressContainer = styled.div.withConfig({
  displayName: "ProgressContainer",
  componentId: "sc-1bnqt8s-6"
})(["position:absolute;bottom:0;left:0;width:100%;"]);
export {
  Frame
};
//# sourceMappingURL=Frame.js.map
